import { UpdateAttentionClasses } from 'models/requests/UpdateAttentionClasses';
import axios from 'utils/axios';

class AttentionClassesService {
    async updateAttentionClasses(attentionClasses: UpdateAttentionClasses): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/UpdateClasseDiAttenzione', attentionClasses);
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch update Params');
        }
    }
}

export default AttentionClassesService;
